// Kept separate from routes.js, which lazy-imports every authenticated route.
// Importing this constant from there pulls the whole app into the public bundle.
export const ROUTES = {
  SIGNIN: "/signin",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  SIGNOUT: "/signout",
  DASHBOARD: "/dashboard",
  PERSONAL_DOCUMENTS: "/personal-documents",
  PROFILE: "/profile",
  NOTIFICATION_PREFERENCES: "/notification-preferences",
  PORTFOLIO: "/portfolio",
  DEALFLOW: "/dealflow",
  ONBOARDING: "/onboarding",
};
